import { ENV, environmentVariable } from '@application/env';
import fetch from 'cross-fetch';

const DEFAULT_LANGUAGE_FALLBACK =
  'https://tipaw-test-assets.s3.eu-west-3.amazonaws.com/file_uploads/fr.json';
const serverUrl = environmentVariable(ENV.LOCALES_SERVER_URL);

export const getTranslationUrl = async (lng: string) => {
  const path = `webhook/locales/${lng}`;
  const response = await fetch(`${serverUrl}${path}`, {
    method: 'get',
    headers: { 'Cache-Control': 'no-cache' },
  })
    .then((data) => data.json())
    .catch((err) => {
      console.error(err);
      return DEFAULT_LANGUAGE_FALLBACK;
    });

  return response?.url;
};
